import React from "react";
import "./portfoliosub2.css";
import Select from "./portfolioselect3";
import {
  FaUserTie,
  FaTags,
  FaCalendarAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";
import heroImage from "../images/bbimg.jpg";

const Portfoliodetail2 = () => {
  return (
    <div className="sub-page">
      {/* ===== Portfolio Header ===== */}
       <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="content-overlay">
          <h1 className="portfolio-title"> Portfolio Details</h1>
          <div className="breadcrumb">
            Home <span className="separator"> &gt; </span>{" "}
            <span style={{ color: "yellow" }}>Portfolio Details</span>
          </div>
        </div>
      </section>

      {/* ===== Image with Overlay Info ===== */}
      <section className="image-overlay-section">
        <div className="image-container">
          <img
            src={heroImage}
            alt="Cleaning Service"
            className="main-image"
          />

          {/* ===== Overlay Info on Image ===== */}
          <div className="overlay-info-card">
            <div className="info-item">
              <FaUserTie className="info-icon" />
              <div>
                <p className="info-label">Client :</p>
                <p className="info-text">Road Freight Transportation</p>
              </div>
            </div>

            <div className="info-item">
              <FaTags className="info-icon" />
              <div>
                <p className="info-label">Category :</p>
                <p className="info-text">Office Cleaning Services</p>
              </div>
            </div>

            <div className="info-item">
              <FaCalendarAlt className="info-icon" />
              <div>
                <p className="info-label">Date :</p>
                <p className="info-text">22 March, 2025</p>
              </div>
            </div>

            <div className="social-icons">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><FaPinterestP /></a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Office Cleaning Description ===== */}
      <section className="sub-content">
        <div className="content-container">
          <h2>Office Cleaning</h2>
          <p>
            Pretium convallis lacinia. Quisque ac eros urna. Mauris eu molestie
            odio. Nullam id consectetur nibh, at luctus elit. Sed ipsum nunc,
            elementum vitae suscipit sit amet, malesuada in turpis. Vivamus vel
            augue congue, maximus tortor sed, malesuada urna. Nunc dictum diam
            eros. Nulla sit amet interdum tellus, a hendrerit dui. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit.
          </p>
          <p>
            Experience and reputation – cleaning companies who have a
            long-standing reputation tend to charge a premium for their cleaning
            services. Frequency of Cleaning – the more you clean, the less you
            are charged by the cleaning companies.
          </p>
        </div>
      </section>

      <Select />
    </div>
  );
};

export default Portfoliodetail2;
